<!--
 * @Description: 
 * @Author: 诺
 * @Date: 2022-04-26 13:47:54
 * @LastEditors: 诺
 * @LastEditTime: 2022-06-21 16:49:24
-->
<template>
  <div class="authGuideBg" >
    <img src="https://assets.rurushishi.com/activies/activityCenter/guide.gif" />
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
   computed: {
    authGuideBg() {
      return { height:`${ this.getHeight()}px` };
    },
  },
  created() {
    console.log()
  },
  methods: {
    getHeight() {
      var clientHeight = 0;
      if (document.body.clientHeight && document.documentElement.clientHeight) {
        var clientHeight =
          document.body.clientHeight < document.documentElement.clientHeight
            ? document.body.clientHeight
            : document.documentElement.clientHeight;
      } else {
        var clientHeight =
          document.body.clientHeight > document.documentElement.clientHeight
            ? document.body.clientHeight
            : document.documentElement.clientHeight;
      }
      return clientHeight;
    },
  },
};
</script>
<style lang="scss" scoped>
.authGuideBg {
  box-sizing: border-box;
  bottom: 0;
  left: 0;
  top:0;
  right:0;
  position: fixed;
  z-index:99999;
  background-color: rgba(0, 0, 0, 0.7);
  img {
    width: 200px;
    position: fixed;
    bottom: 10px;
    right: 0;
  }
}
</style>
